import { Action } from 'redux';

import {
    APIFailureAction,
    APIRequestAction,
    APISuccessAction,
} from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

export type PlaceType = 'all' | 'counties' | 'countries';

// API
export interface CommonPlaceTopicsFetchAction extends Action {
    readonly placeType: string;
    readonly search: string;
    readonly after: number;
}

export interface CommonPlaceTopicsFetchNormalizedResponse  extends NormalizedResponse {
    readonly result: { category: number; followingTopics: number[], topics: number[] };
}

export const COMMON_PLACE_TOPICS_FETCH_REQUEST = 'COMMON_PLACE_TOPICS_FETCH_REQUEST';
export interface CommonPlaceTopicsFetchRequestAction extends CommonPlaceTopicsFetchAction, APIRequestAction {
    readonly type: typeof COMMON_PLACE_TOPICS_FETCH_REQUEST;
}

export const COMMON_PLACE_TOPICS_FETCH_SUCCESS = 'COMMON_PLACE_TOPICS_FETCH_SUCCESS';
export interface CommonPlaceTopicsFetchSuccessAction extends CommonPlaceTopicsFetchAction, APISuccessAction<CommonPlaceTopicsFetchNormalizedResponse> {
    readonly type: typeof COMMON_PLACE_TOPICS_FETCH_SUCCESS;
    readonly hasNext: number;
    readonly hasPrevious: number;
}

export const COMMON_PLACE_TOPICS_FETCH_FAILURE = 'COMMON_PLACE_TOPICS_FETCH_FAILURE';
export interface CommonPlaceTopicsFetchFailureAction extends CommonPlaceTopicsFetchAction, APIFailureAction {
    readonly type: typeof COMMON_PLACE_TOPICS_FETCH_FAILURE;
}

export const commonPlaceTopicsFetch = {
    request: (placeType: string, search: string, after: number): CommonPlaceTopicsFetchRequestAction => ({
        type: COMMON_PLACE_TOPICS_FETCH_REQUEST,
        placeType, search, after,
    }),
    success: (placeType: string, search: string, after: number, hasNext: number, hasPrevious: number, response: CommonPlaceTopicsFetchNormalizedResponse): CommonPlaceTopicsFetchSuccessAction => ({
        type: COMMON_PLACE_TOPICS_FETCH_SUCCESS, response,
        placeType, search, after, hasNext, hasPrevious,
    }),
    failure: (placeType: string, search: string, after: number, error: any): CommonPlaceTopicsFetchFailureAction => ({
        type: COMMON_PLACE_TOPICS_FETCH_FAILURE, error,
        placeType, search, after,
    }),
};

// Triggers
export const COMMON_PLACE_TOPICS_LOAD = 'COMMON_PLACE_TOPICS_LOAD';

export interface CommonPlaceTopicsLoadAction extends CommonPlaceTopicsFetchAction {
    readonly type: typeof COMMON_PLACE_TOPICS_LOAD;
}

export const commonPlaceTopicsLoad = (placeType: string, search: string, after?: number): CommonPlaceTopicsLoadAction => ({
    type: COMMON_PLACE_TOPICS_LOAD,
    placeType, search, after,
});

export const COMMON_PLACE_TOPICS_SEARCH = 'COMMON_PLACE_TOPICS_SEARCH';

export interface CommonPlaceTopicsSearchAction extends Action {
    readonly type: typeof COMMON_PLACE_TOPICS_SEARCH;
    readonly placeType: string;
    readonly search: string;
}

export const commonPlaceTopicsSearch = (placeType: string, search: string): CommonPlaceTopicsSearchAction => ({
    type: COMMON_PLACE_TOPICS_SEARCH,
    placeType, search,
});

export const COMMON_PLACE_TOPICS_UPDATE_SEARCH = 'COMMON_PLACE_TOPICS_UPDATE_SEARCH';

export interface CommonPlaceTopicsUpdateSearchAction extends Action {
    readonly type: typeof COMMON_PLACE_TOPICS_UPDATE_SEARCH;
    readonly search: string;
}

export const commonPlaceTopicsUpdateSearch = (search: string): CommonPlaceTopicsUpdateSearchAction => ({
    type: COMMON_PLACE_TOPICS_UPDATE_SEARCH,
    search,
});
